<template>
  <ButtonOutline
    class="create-poi"
    :class="{
      'create-poi__active': active
    }"
    :iconLeft="iconPoiSmall"
    :buttonText="t('general__data__create')"
    size="medium-icon"
    @onClicked="handleClick"
  />
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import ButtonOutline from './ButtonOutline.vue'
import { useI18n } from 'vue-i18n'
import iconPoiSmall from '@/assets/icons-general/icon-poi-small.svg'
const { t } = useI18n()
interface EMITS {
  (e: 'createPoi', val: boolean)
}
const emits = defineEmits<EMITS>()
const active = ref(false)

function handleClick() {
  active.value = !active.value
  emits('createPoi', active.value)
}
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/styles/variables.scss' as old-variables;
.create-poi {
  background-color: variables.$color-background;
  border: none;
  color: variables.$color-text-secondary;
  display: block;
  font-size: 10px;
  line-height: 12px;
  padding: 4px 6px;
  position: absolute;
  right: 78px;
  text-align: center;
  top: old-variables.$margin-medium + variables.$layout-top-bar-height;
  z-index: variables.$z-index-map-toolbox;
  &:hover {
    border: none;
  }
  &__active {
    background-color: variables.$color-primary;
    color: variables.$color-pure-white;
  }
  &img {
    color: variables.$color-text-secondary;
    height: 16px;
    width: 16px;
  }
}
</style>
